import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen, faPeopleGroup } from '@fortawesome/free-solid-svg-icons';
import UserMenuContent from './UserMenuContent';
import { useEffect, useState } from 'react';

const HeaderMenu = ({ open, isAuthenticated, sandboxSignInUrl, onOpenChange }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 760);

  useEffect(() => {
    const handleResize = () => {
      const newIsMobile = window.innerWidth <= 760;
      if (isMobile && !newIsMobile && open) {
        onOpenChange(false);
      }
      setIsMobile(newIsMobile);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMobile, open, onOpenChange]);

  return (
    <>
      <div className={`menu-container ${open ? 'active' : ''}`} id="menu">
        <a className="menu-item" href="/training">
          <FontAwesomeIcon icon={faBookOpen} className="menu-item-icon" /> Training
        </a>
        <a className="menu-item" href="/consulting">
          <FontAwesomeIcon icon={faPeopleGroup} className="menu-item-icon" /> Consulting
        </a>
        {open && <UserMenuContent isAuthenticated={isAuthenticated} sandboxSignInUrl={sandboxSignInUrl} />}
      </div>
    </>
  );
};

export default HeaderMenu;
